import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 560px;
  max-width: 90vw;
  max-height: 80vh;
  overflow: auto;
`;

export const Title = styled.h3`
  margin: 0 0 4px;
  font-size: 18px;
`;

export const Subtitle = styled.p`
  margin: 0 0 16px;
  font-size: 13px;
  color: #666;
`;

export const EmptyState = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

export const Th = styled.th`
  padding: 8px 6px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  text-align: left;
  color: #888;
`;

export const Td = styled.td`
  padding: 8px 6px;
  border-bottom: 1px solid #f3f3f3;
`;

export const QtyInput = styled.input`
  width: 70px;
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid #ddd;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

export const OutlineButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #0090d3;
  background: #fff;
  color: #0090d3;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #0090d3;
  color: #fff;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
